import getConfig from 'next/config'
import { buildQueryString } from 'helpers/wordpress'
import { getApiURL } from 'helpers/middleware'

const { publicRuntimeConfig } = getConfig()
const { APP_VERSION } = publicRuntimeConfig

/**
 * Get boats listing data.
 * @param queryParams
 * @returns string
 */
const getBoatApiURL = (queryParams = {}) => {
    const params = { ...queryParams }
    return `${getApiURL('boats')}?version=${APP_VERSION}${params ? `&${buildQueryString(params)}` : ''}`
}

export default getBoatApiURL
